// extracted by mini-css-extract-plugin
export default {"textInput":"Input_textInput__RpSsG","activeScale":"Input_activeScale__20hdN","inactiveScale":"Input_inactiveScale__OTnQS"};